<script lang="ts" setup>
import { computed, type PropType } from 'vue';

import { MyOrdersListType } from '@exchange/libs/order/shared-model/src/lib/order-essentials';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

import TimeFromNow from './TimeFromNow.vue';

const props = defineProps({
  forceAbsoluteTime: { type: Boolean, required: true },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  listType: { type: String as PropType<MyOrdersListType>, required: true },
});

const time = computed(() => (props.listType === MyOrdersListType.open ? props.order.time : props.order.timeLastUpdated));
</script>

<template>
  <time-from-now
    v-if="time"
    class="order-time"
    :date="time"
    :force-absolute-time="forceAbsoluteTime"
  />
</template>

<style lang="scss">
.order-time {
  color: var(--order-time-color);
}
</style>
